const zohoManuals = [
    {
        title: 'Handleiding Stage Docenten',
        link: 'https://learn.zohopublic.eu/external/manual/handleiding-stage-docenten?p=403e781d6c694619bb23029b17ab34318027a840afc5bb0bf46be90b75ae51c242c3dbd89b634a0b7898420c242124c9',
        access: 'teacher'
    },
    {
        title: 'Handleiding Stage Leerlingen',
        link: 'https://learn.zohopublic.eu/external/manual/handleiding-stage-leerlingen?p=403e781d6c694619bb23029b17ab34319986f26bdd27dd1cfac1a732705748f3bba97ba490c7f0c4797d014a1ec3b316',
        access: 'student'
    },
    {
        title: 'Handleiding CK-Dossier Docenten',
        link: 'https://learn.zohopublic.eu/external/manual/handleiding-ck-dossier-docenten?p=403e781d6c694619bb23029b17ab3431d1034ae02dc05727fc8e0365d45c73a8f430b02a5fb0808147027eca2add75f7',
        access: 'teacher'
    },
    {
        title: 'Handleiding CK-Dossier Leerlingen',
        link: 'https://learn.zohopublic.eu/external/manual/algemene-handleiding-ck-dossier-leerling?p=403e781d6c694619bb23029b17ab343156f69e041b2a3511a26efe2bfcf0db8a72b3e9db6874c5b809b1d9634f251134',
        access: 'student'
    },
    {
        title: 'Handleiding Portfolio Docenten',
        link: 'https://learn.zohopublic.eu/external/manual/algemene-handleiding-portfolio-docenten?p=403e781d6c694619bb23029b17ab34314f390bb053be69db0db05675c712708d89aeb19a7619709e258c5c3b5b43fcae',
        access: 'teacher'
    },
    {
        title: 'Handleiding Portfolio Leerlingen',
        link: 'https://learn.zohopublic.eu/external/manual/algemene-handleiding-portfolio-leerling?p=403e781d6c694619bb23029b17ab34316889a299da1442e97bfc88d67e035a28e5b098d293136751f480bb41740946f5',
        access: 'student'
    },
    {
        title: 'Handleiding PWS Docenten',
        link: 'https://learn.zohopublic.eu/external/manual/handleiding-pws-docenten-1?p=403e781d6c694619bb23029b17ab34313c7a107420db3e3c1779e322f415a3af1f89eb961cfee31622406c886174786d',
        access: 'teacher'
    },
    {
        title: 'Handleiding TTO',
        link: 'https://learn.zohopublic.eu/external/manual/handleiding-tto?p=403e781d6c694619bb23029b17ab34314cc7e634425045d9c117da36f6aa4497abc71b59a02e001f2a3fa5356f26372f',
        access: 'teacher'
    },
    {
        title: 'Nieuw project maken en klassen koppelen',
        link: 'https://learn.zohopublic.eu/external/manual/handleiding-project-klaarzetten/article/nieuw-project-maken?p=403e781d6c694619bb23029b17ab3431540bd41f58fcb1f28bba332b96cc98e77df03ef0235da13824ae76b1f96dc127',
        access: 'teacher'
    }
];

export default zohoManuals;
